/* eslint-disable */
export const PASSWORD_REGEX = /^(?=.{8,})/;
export const EMAIL_REGEX = /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/;
export const ERROR_INVALID_PASSWORD = 'Password must contain at least 8 characters, at least one capital letter and one digit';
export const ERROR_INVALID_EMAIL = 'Email is invalid';
export const ERROR_PASSWORD_CONFIRMATION = 'Passwords don\'t match';
export const ERROR_EMPTY_PASSWORD = 'Password is invalid';
